import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-align-left fs14 fw600 mb-6" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = { class: "fs22 fw700 mr-8 text-nowrap" }
const _hoisted_4 = {
  key: 0,
  class: "fs12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IndicatorsWrapper = _resolveComponent("IndicatorsWrapper")!

  return (_openBlock(), _createBlock(_component_IndicatorsWrapper, {
    list: $options.unfriendlyCountryInfoList,
    title: "Ограничения"
  }, {
    tooltip: _withCtx(() => [
      ($options.isEuropeanUnionCountry)
        ? (_openBlock(), _createBlock(_component_Tooltip, {
            key: 0,
            triggers: ['click']
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Приведена информация об ограничениях, введенных Европейским союзом ", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    item: _withCtx(({ item }) => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(item.title), 1),
      (item.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("strong", _hoisted_3, _toDisplayString(item.value), 1),
            _createElementVNode("div", null, [
              (item.measure)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "млн $"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["list"]))
}